// extracted by mini-css-extract-plugin
export default {"container":"ProfileDropdownButton_container__zfZYJ","profileIcon":"ProfileDropdownButton_profileIcon__S7LnK"};